<template>
    <div >
        <top-bar :showBack="true" @onClickBack="onClickBack($event)"></top-bar>
        <div class="page-register-otp">
            <div class="title-text">{{lbl.register.mobile_number_validate}}</div>
            <div class="message-text">
                <div>{{lbl.register.send_otp_msg}}</div>
                <div class="pt-2">{{registerData.contactNumber | phone_format}}</div>
            </div>
            <div class="msg-otp">{{lbl.register.please_enter_otp}}</div>
            <div>
                <input-number inputId="input-otp"
                            v-model="otpModel.otp"
                            :inputLbl="lbl.register.otp"
                            :inputMinLength="6"
                            :inputMaxLength="6"
                            :isFirstSave="isFirstSave"
                            :isShowErrorLbl="true"
                            :errorInfo="errorInfo"
                            :centerInput="true"
                            @onChange="onInputOtpChange($event)"
                ></input-number>
            </div>
            <div class="text-refcode">
                {{lbl.register.refcode}} {{otpModel.refcode}}
            </div>
            <div class="error-message">{{errorMessage}}</div>
            <div>
                <button class="btn-black"
                        :class="{'disable' : isDisableSubmit}"
                        @click="clickContinue()">{{lbl.default.continue}}</button>
            </div>
            <div>
                <div class="text-btn-link" :class="{'resend-otp': this.otpModel.timeout}" @click="clickResend()">{{lbl.register.resend_otp}} {{otpModel.textTimeRemain}}</div>
            </div>
        </div>
        <modal view="register-otp" :busModal="busModal"></modal>
    </div>
</template>
<script>
import Vue from 'vue';
import Locale from "@/helper/locale/locale.js";
import TopBar from "@/components/TopBar.vue";
import Account from "@/helper/AccountHelper.js";
import InputNumber from "@/components/common/input/Number.vue";
import BzbsOtp from "@/service/BzbsOtp.js";
import Modal from "@/components/modal/Modal.vue";
import Util from "@/helper/Utility.js";
import DiorApi from "@/service/dior/DiorApi.js";
import LineFunction from '@/helper/facade/LineFunction.js';
import { TrackingService } from "@/helper/TrackingHelper";

/**
 * @property {String} contactNumber (require)
 *
 * @event checkedOtp
 */
export default {
    name: "RegisterOtp",
    components: {
        TopBar,
        InputNumber,
        Modal,
    },
    props: {
        // contactNumber: String,

        registerData: Object,
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),
            isFirstSave: true,
            errorInfo: {
                isValid: true,
                msg: '',
            },

            otpModel: {
                otp: '',
                Tmpotp: '',
                refcode: '',
                timeLength: 300,
                timeRemain: 0,
                interval: null,
                timeout: false,
                textTimeRemain: '00:00',
            },
            qrValue: {
                customerId: '',
                counterId: '',
                phone: '',
            },
            errorMessage: '',
            channel: "register",
            isDisableSubmit: true,
            isFlowQr: false,
            busModal: new Vue(),
            tracking: new TrackingService(this)
        };
    },
    created: function() {
        this.flowQrScan();
        console.log("registerotp");
        console.log(this.registerData);

    },
    mounted: function() {

        this.requestOtp();
    },
    methods: {
        onClickBack: function() {
            console.log('click back');
            this.setOtpTimeOut();
            this.changePage('register-phone');
        },

        changePage: function(changeTo) {
            this.$emit('onChangePage', { page: changeTo });
        },
        onInputOtpChange: function(data) {
            this.Tmpotp = data;
            if (data.length == 6 && this.otpModel.timeRemain > 0) {

                this.isDisableSubmit = false;
            } else {
                this.isDisableSubmit = true;
            }
        },
        clickContinue: function() {
            // this.changePage('register-form');
            // this.requestOtp();
            if (this.otpModel.timeRemain <= 0) {

                return;
            }
            if (this.validateFormOtp()) {
                if (this.isFlowQr) {
                    this.checkedOtp();
                } else {
                     this.submitOtp();
                }
                this.tracking.event('register_OTP', 'click_register_OTP');
            }
        },
        validateFormOtp: function() {
            this.errorMessage = '';
            this.isFirstSave = false;
            return this.errorInfo.isValid;
        },

        clickResend: function() {
            if (this.otpModel.timeRemain <= 0) {
                this.otpModel.timeout = false;

                if (this.Tmpotp.length == 6) {
                    this.isDisableSubmit = false;
                }

                this.requestOtp();
            }
        },

        //#region otp
        requestOtp: function() {
            BzbsOtp.requestOtp(this.registerData.contactNumber, null, this.channel).then((res) => {
                console.log(res.data);
                this.otpModel.refcode = res.data.refcode;
                this.runtimeOtp();
            }).catch((err) => {
                if (err.response) {
                    console.log(err.response.data);
                } else {
                    console.log(err);
                    this.showErrorConnectModal();
                }
            });
        },
        runtimeOtp: function() {
            this.otpModel.timeRemain = this.otpModel.timeLength;

            this.setShowTimeOtp();
            this.otpModel.interval = setInterval(() => {
                this.setShowTimeOtp();
            }, 1000);
        },
        setShowTimeOtp: function() {
            if (this.otpModel.timeRemain <= 0) {
                this.setOtpTimeOut();
                return;
            }

            var timeRemain = this.otpModel.timeRemain;
            var min = Math.floor(timeRemain / 60);
            var sec = timeRemain % 60;
            min = min < 10 ? '0' + min : min;
            sec = sec < 10 ? '0' + sec : sec;

            this.otpModel.textTimeRemain = min + ':' + sec;
            this.otpModel.timeRemain -= 1;
        },
        setOtpTimeOut: function() {
            this.otpModel.timeRemain = 0;
            this.otpModel.timeout = true;
            this.otpModel.textTimeRemain = "00:00";
            this.otpModel.otp = '';
            this.isDisableSubmit = true;
            clearInterval(this.otpModel.interval);
        },
        submitOtp: function() {
            var token = Account.getToken();
            BzbsOtp.confirmOtp(token, this.registerData.contactNumber, this.otpModel.refcode, this.otpModel.otp)
                .then((res) => {
                    console.log(res.data);
                    this.checkedOtp()
                    // send to check is member or not
                })
                .catch((err) => {
                    if (err.response) {
                        console.log(err.response.data);
                        var error = err.response.data.error;
                        if (error.id == "2091") {

                            this.errorMessage = this.lbl.register.otp.notcorrect;
                        } else if (error.id == "2092") {
                             this.errorMessage = this.lbl.register.otp.otpexpire;
                        }
                        else {
                            this.errorMessage = error.message;
                        }
                    } else {
                        console.log(err);
                        this.showErrorConnectModal();
                    }
                });
        },
        checkedOtp: function() {

            if (!this.isFlowQr) {

                this.$emit('checkedOtp', data);
            } else {
                var data = {
                    refcode:this.otpModel.refcode,
                    otp: this.otpModel.otp
                }

                this.RegisterProcessMember(data);
            }

        },
        initLiff: function() {
            return new Promise((resolve) => {
                var lineFunction = new LineFunction();
                this.liffId = lineFunction.getLiffId();

                lineFunction.init(this.liffId).then(() => {

                    this.lineIdToken = lineFunction.getIdToken();
                    resolve();
                }).catch((err) => {
                    console.log(err);
                    this.setNotLineRegister();
                    // this.$router.replace('/error');
                });
            });

        },
        RegisterProcessMember: async function(data) {
            await this.initLiff();
            this.registerData.day = Account.getCacheCustom("DiorQrBday");
            this.registerData.month = Account.getCacheCustom("DiorQrBmth");
            //this.sendRegisterMemberQr(this.registerData.day, this.registerData.month, data);

            // console.log('send register qr');
            this.registerData.day = this.registerData.day.length == 1 ? '0' + this.registerData.day : this.registerData.day;
            this.registerData.month = this.registerData.month.length == 1 ? '0' + this.registerData.month : this.registerData.month;

            var token = Account.getToken();
            DiorApi.registerQr(token, this.qrValue.customerId, this.qrValue.counterId, this.qrValue.phone, this.registerData.day, this.registerData.month, data, this.lineIdToken)
                .then((res) => {
                    console.log(res.data);
                    this.$router.push('/profile');
                })
                .catch((err) => {
                    if (err.response) {
                        console.log(err.response.data);
                        var error = err.response.data.error;
                        if (error.id == 2091) {

                            this.errorMessage = this.lbl.register.otp.notcorrect;

                        } else if (error.id == 2092) {

                            this.errorMessage = this.lbl.register.otp.otpexpire;

                        }
                        else {
                            this.errorMessage = error.message;
                        }

                    } else {

                        console.log(err);
                        this.showErrorConnectModal();
                    }
                });
        },
        //#endregion otp

        showErrorConnectModal: function() {

            var configModal = {

                message: this.lbl.error_connect.message,
                strBtnOk: this.lbl.error_connect.btn_close,
            };
            this.busModal.$emit('showErrorConnectModal', configModal);
        },

        flowQrScan: function() {
            this.isFlowQr = false;
            var isQrFlow = this.$route.query.qr;
            if (isQrFlow == true || isQrFlow == 'true') {
                var customerId = Vue.$cookies.get('DiorQrCustomerId');
                var counterCode = Vue.$cookies.get('DiorQrCounterCode');
                var phone = Vue.$cookies.get('DiorQrPhone');

                if (!Util.isEmptyStr(customerId) && !Util.isEmptyStr(counterCode) && !Util.isEmptyStr(phone)) {
                    //this.startFlowQr(phone);
                    this.qrValue.customerId = customerId;
                    this.qrValue.counterId = counterCode;
                    this.qrValue.phone = phone;
                    this.isFlowQr = true;
                    this.channel = "process";

                    return true;
                }
            }

            return false;
        },

    },
}
</script>
<style lang="scss">
    @import "@/style/page/RegisterOtp.scss";
</style>
